import React from 'react';
import { useNavigate } from 'react-router-dom';
import { knowledgeBase } from '../data/knowledgeBase';

const FONT = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const styles = {
  page: { minHeight: '100vh', background: '#faf8f3', padding: '24px 16px', fontFamily: FONT, boxSizing: 'border-box' },
  wrap: { maxWidth: 900, margin: '0 auto' },
  back: { background: 'none', border: 'none', color: '#8C6D1F', cursor: 'pointer', padding: 0, fontSize: 14, marginBottom: 12, fontFamily: FONT },
  h1: { fontSize: 26, fontWeight: 700, color: '#1a1a1a', margin: '8px 0 16px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 },
  card: { background: '#ffffff', border: '1px solid #d8c9a8', borderRadius: 10, padding: 22 },
  cardTitle: { fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '0 0 8px' },
  cardText: { fontSize: 14, color: '#7f7f7f', margin: 0, lineHeight: 1.5 },
  soon: { fontSize: 11, fontWeight: 700, color: '#8C6D1F', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: 14 },
};

export default function KnowledgeBase() {
  const navigate = useNavigate();
  return (
    <div style={styles.page}>
      <div style={styles.wrap}>
        <button type="button" onClick={() => navigate('/training')} style={styles.back}>← Back to training</button>
        <h1 style={styles.h1}>{knowledgeBase.title}</h1>
        <div style={styles.grid}>
          {knowledgeBase.sections.map((s) => (
            <div key={s.id} style={styles.card}>
              <div style={styles.cardTitle}>{s.title}</div>
              <p style={styles.cardText}>{s.description}</p>
              {s.steps.length === 0 && <div style={styles.soon}>Content coming soon</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
